// Vite は VITE_ 接頭辞の env をビルド時にインライン化する（import.meta.env）。
// 値の解決先は mode ごとの .env ファイル（.env.development / .env.dev / .env.prod）。

// API のベース URL。未設定を無言で同一オリジンへフォールバックさせず、api.ts で明示的に失敗させる。
export const API_URL: string = import.meta.env.VITE_API_URL ?? "";

// 環境識別子（local / dev / prod）。
export const APP_ENV: string = import.meta.env.VITE_ENV ?? "local";

// 開発環境（local / dev）かどうか。ヘッダの「開発版」バッジ表示に使う。
export const IS_DEVELOPMENT = APP_ENV !== "prod";

// package.json の version（vite.config.ts の define で注入）。
// ngtg_msc の appVersionProvider（pubspec の version 表示）に対応する。
export const APP_VERSION: string = __APP_VERSION__;
